
import Vue from "vue";
import statistics from "~/mixins.js/statistics";

Vue.mixin(statistics);

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      // NOTE: rest of the data props have been abstracted into the statistics.js mixin
    };
  },
  computed: {
    block () {
      return this.post?.acf?.statistics_config;
    },
    availableTabs () {
      return this.block[this.currentTaxonomySlug].map(
        tab => tab.display_name,
      );
    },
    currentTaxonomySlug () {
      return this.taxonomySchema[this.selectedTaxonomy].slug;
    },
    currentTaxonomyProp () {
      return this.taxonomySchema[this.selectedTaxonomy].prop;
    },
    currentTaxonomyStatTypesPath: {
      get () {
        return this.taxonomyStatTypes?.[this.currentTaxonomyProp]?.[
          this.statsTabs.currentTab
        ];
      },
      set (value) {
        this.taxonomyStatTypes[this.currentTaxonomyProp][
          this.statsTabs.currentTab
        ] = value;
      },
    },
    currentTabBlock () {
      if (this.statsTabs.currentTab && this.block[this.currentTaxonomySlug]) {
        return this.block[this.currentTaxonomySlug]?.find(
          statGroup => statGroup.display_name === this.statsTabs.currentTab,
        );
      }
      return null;
    },
    selectedSeason () {
      return (
        this.statsFilters?.seasons?.selectedSeason?.id || this.defaultSeason?.id
      );
    },
    selectedTaxonomy () {
      return this.statsFilters.taxonomy.selectedTaxonomy;
    },
  },
  watch: {
    "availableTabs": {
      immediate: true,
      handler (availableTabs) {
        if (availableTabs?.length) {
          this.statsTabs.defaultTabs = availableTabs;
          this.statsTabs.currentTab = availableTabs[0];
        }
      },
    },
    "statsTabs.currentTab": {
      handler () {
        this.isLoading = true;
      },
    },
    "currentTabBlock": {
      immediate: true,
      handler (currentTabBlock) {
        this.allStatTypesInitialDataWithinCurrentTaxonomy =
          this.getAllStatTypesFromBlock({
            taxonomy: this.currentTaxonomySlug,
            block: currentTabBlock,
          });
      },
    },
    "allStatTypesInitialDataWithinCurrentTaxonomy": {
      immediate: true,
      async handler (allStatTypesInitialDataWithinCurrentTaxonomy) {
        if (allStatTypesInitialDataWithinCurrentTaxonomy) {
          this.recalibrateCustomChartData();
        }

        if (this.currentTaxonomyStatTypesPath?.length) {
          this.isLoading = false;
          return;
        }
        this.currentTaxonomyStatTypesPath =
          await this.createChartDataForAllStatTypes();
      },
    },
    "selectedSeason": {
      async handler () {
        this.resetChartData();
        this.resetCustomChartData();
        this.currentTaxonomyStatTypesPath =
          await this.createChartDataForAllStatTypes();
        this.recalibrateCustomChartData();
      },
    },
  },
};
